export default "__VITE_ASSET__k2Sxp8yp__"